// `false` and `''` are both falsy values that are valid for use in forms,
// so only check to ensure the value is not `null` or `undefined`.
const isFalsy = value => value === null || value === undefined;

// This isn't a perfect object check, but it's good enough for what we're doing
// here.
const isObject = value => !Array.isArray(value) && typeof value === 'object';

const formatInitialValues = (initialValues, formattedValues) => {
  if (isFalsy(formattedValues)) {
    return initialValues;
  }

  if (!Array.isArray(initialValues) && typeof initialValues === 'object') {
    const formattedObject = {};

    Object.keys(initialValues).forEach((key) => {
      const newFormattedValue = isObject(formattedValues) ? formattedValues[key] : undefined;
      formattedObject[key] = formatInitialValues(initialValues[key], newFormattedValue);
    });

    return formattedObject;
  }

  return formattedValues;
};

// This lets us chain an unlimited number of objects. For example:
// formatInitialValues(initialValues, site.theme, facility.theme);
export default (initialValues, formattedValues, ...rest) => rest.reduce(
  (currentValues, nextValues) => formatInitialValues(currentValues, nextValues),
  formatInitialValues(initialValues, formattedValues),
);
